/**
 * Build a one-line subtitle for a bereavement card / detail page.
 *
 *   - When the deceased IS the registered member (relationship === "Member"),
 *     show "Registered member · UKC-xxxx".
 *   - When the member is family of the deceased (relationship === "Family"),
 *     show "Family of <member name> · UKC-xxxx".
 *   - When the relationship is anything else (Spouse, Parent, Child, etc.),
 *     show "<relationship> of <member name> · UKC-xxxx".
 */
export function bereavementSubtitle(b) {
  if (!b) return "";
  const rel = b.relationship || "Member";
  const memberName = b.memberName || "";
  const ukc = b.memberNumber || b.memberUkc || "";
  const ukcSuffix = ukc ? ` · ${ukc}` : "";

  if (rel === "Member" || rel === "Self") {
    return `Registered member${ukcSuffix}`;
  }
  if (rel === "Historical") {
    // Legacy data — bereavement was bulk-imported but not yet reattributed.
    return memberName ? `Imported · ${memberName}` : "Imported";
  }
  if (rel === "Family") {
    return memberName ? `Family of ${memberName}${ukcSuffix}` : `Family${ukcSuffix}`;
  }
  return memberName ? `${rel} of ${memberName}${ukcSuffix}` : rel;
}
